import { Circle } from 'lucide-react';
import React from 'react';
import { cn } from '@/lib/utils';

const importanceValues = [1, 2, 3, 4, 5];

interface ImportanceProps {
    weight: number;
}

function Importance({ weight }: ImportanceProps): React.JSX.Element {
    return (
        <div className="flex h-5 flex-row items-center justify-start gap-0">
            {importanceValues.map((item) => (
                <Circle
                    key={item}
                    className={cn(
                        'h-1.5 w-3 fill-current',
                        weight < item ? 'text-muted-foreground/20' : 'text-muted-foreground/80',
                        weight < 3 ? 'invisible' : 'visible',
                    )}
                />
            ))}
        </div>
    );
}

export default Importance;
